import React, { useEffect, useState } from 'react'
import { ILogObject, IProject } from 'types'
import api from 'helpers/api'
import { capitaliseFirstLetter } from 'helpers/utils'
import { PROJECT } from 'app-constants'
import { useApplicationStore } from 'hooks/application'
import Skeleton from 'components/skeleton'

interface PublicProps {
  userId?: string
}

const projectLine = (contextProject: Pick<IProject, 'publicId' | 'name'> | null) => {
  if (contextProject) {
    return (
      <span>
        inside the <b>{contextProject.name}</b> project
      </span>
    )
  } else {
    return null
  }
}

const Public: React.FC<PublicProps> = ({ userId }) => {
  const { displayErrorMessage } = useApplicationStore()

  const [publicContributions, setPublicContributions] = useState<ILogObject[]>()

  useEffect(() => {
    if (userId) {
      api
        .getPublicContributions(userId)
        .then((response) => {
          setPublicContributions(response.data)
        })
        .catch((error) => {
          displayErrorMessage(error)
        })
    } else {
      setPublicContributions(undefined)
    }
  }, [userId])

  return (
    <div className="text-base mt-10 pb-2.5">
      Recent Public {capitaliseFirstLetter(PROJECT)} Contributions
      <div className="mt-5 text-sm">
        {userId && publicContributions ? (
          publicContributions.length !== 0 ? (
            <div>
              {publicContributions.map((contribution, index) => {
                const dateString = new Date(contribution.createdAt).toLocaleDateString()
                const prevDateString =
                  index > 0 ? new Date(publicContributions[index - 1].createdAt).toLocaleDateString() : null
                const showDateString = dateString !== prevDateString
                return (
                  <div key={index} className={`flex items-center h-[30px] ${showDateString ? 'mt-5' : 'mt-0'}`}>
                    <div className="flex items-center h-full min-w-20">{showDateString ? dateString : ''}</div>
                    <div className="h-full flex items-center border-l-[1px] border-divider truncate ml-2.5 pl-2.5">
                      performed
                      <b className="ml-[5px] mr-[5px]">{contribution.verb}</b> inside the{' '}
                      <b className="ml-[5px] mr-[5px]">
                        {contribution.contextProcess
                          ? contribution.contextProcess.name
                          : contribution.contextTable
                            ? contribution.contextTable.name
                            : ''}{' '}
                      </b>
                      <span className="mr-[5px]">{contribution.resource}</span>{' '}
                      {projectLine(contribution.contextProject)}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="italic">No public {PROJECT} contributions</div>
          )
        ) : (
          <Skeleton className="rounded w-[430px] h-[30px]" />
        )}
      </div>
    </div>
  )
}

export default Public
